import React, { useEffect } from 'react';
import { Form, Input, Button, Checkbox, Divider } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import SupportMenu from '../../Common/Support/SupportMenu';

const readAutofillCredentials = () => {
  const username =
    document.querySelector('.login-form input[autocomplete="username"]')?.value ??
    '';
  const password =
    document.querySelector('.login-form input[autocomplete="current-password"]')
      ?.value ?? '';

  return { username, password };
};

const LoginFormComponent = ({ confirm }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    const syncAutofillToForm = () => {
      const { username, password } = readAutofillCredentials();
      if (!username && !password) return;

      const current = form.getFieldsValue();
      const patch = {};
      if (username && !current.username) patch.username = username;
      if (password && !current.password) patch.password = password;
      if (Object.keys(patch).length > 0) {
        form.setFieldsValue(patch);
      }
    };

    const onAutofillAnimation = event => {
      if (event.animationName === 'beonLoginAutofillStart') {
        syncAutofillToForm();
      }
    };

    document.addEventListener('animationstart', onAutofillAnimation, true);
    const timers = [100, 300, 800].map(delay =>
      window.setTimeout(syncAutofillToForm, delay),
    );

    return () => {
      document.removeEventListener('animationstart', onAutofillAnimation, true);
      timers.forEach(clearTimeout);
    };
  }, [form]);

  const handleFinish = values => {
    const autofill = readAutofillCredentials();
    confirm({
      ...values,
      username: values.username || autofill.username,
      password: values.password || autofill.password,
    });
  };

  return (
    <div className="login-form-component">
      <div className="login-beon-logo" />

      <Divider type="vertical" className="login-divider" />

      <Form
        name="login_form"
        form={form}
        initialValues={{ remember: true }}
        className="login-form"
        onFinish={handleFinish}
      >
        <Form.Item
          name="username"
          rules={[
            {
              required: true,
              message: 'Por favor digite seu usuário',
            },
          ]}
        >
          <Input
            className="login-form-input"
            autoComplete="username"
            prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
            placeholder="Usuário"
          />
        </Form.Item>

        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: 'Por favor digite sua senha',
            },
          ]}
        >
          <Input.Password
            className="login-form-input"
            autoComplete="current-password"
            prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
            placeholder="Senha"
          />
        </Form.Item>

        <Form.Item name="remember" valuePropName="checked">
          <Checkbox>Lembrar</Checkbox>
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            Entrar
          </Button>
        </Form.Item>

        <SupportMenu />
      </Form>
    </div>
  );
};

export default LoginFormComponent;
